module.exports = __webpack_public_path__ + "static/media/formula.f7539c1d.jpg";